import ClubItemBase from "./club_item_base";

const {ccclass, property} = cc._decorator;

/**
 * 需要新增的游戏item
 */
@ccclass
export default class ClubGameItem extends ClubItemBase {

    @property(cc.Sprite)
    gameIcon: cc.Sprite = null;

    @property(cc.Label)
    gameName: cc.Label = null;


    onChose(){

        this.dispatchEvent("club_choose_add_game",this.itemIndex);
    }

}
